export default __webpack_public_path__ + "static/media/careerpoint.6aea063a.svg";